import PropTypes from "prop-types";
import React from "react";

import CancelButton from "../../../provider-management/components/buttons/CancelButton";
import SaveButton from "../../../provider-management/components/buttons/SaveButton";

export default function PrimarySectionActions({ disabled, isSaving, onCancel, onSave }) {
  return (
    <div className="flex justify-end pt-2">
      <div className="flex w-full gap-2 md:w-1/2 md:justify-end">
        <CancelButton disabled={isSaving} onClick={onCancel} />
        <SaveButton disabled={disabled} onClick={onSave} label="Save" />
      </div>
    </div>
  );
}

PrimarySectionActions.propTypes = {
  disabled: PropTypes.bool.isRequired,
  isSaving: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};
